import moment from 'lib/utils/date';

const filterNames = {
  'all': '',
  'orders': 'type=SERVICE_DEBIT_MERCHANT&type=PURCHASE&type=PURCHASE_BILL&type=REFUND_DEBIT&status=SUCCESS&status=REFUND_SUCCESS&status=REFUND_PROCESSING&',
  'payouts': 'type=PAYOUT&type=REFUND&',
  'bills': 'type=CASUAL&type=SUBSCRIPTION&type=TARIFF&type=TICKET&type=TIPS&status=NEW&',
};

export default {
  getTypeFromFilter(filterBy) {
    return filterNames[filterBy] || '';
  },

  // eslint-disable-next-line complexity
  addMissedDays(data, name) {
    let withMissedDays = [];

    for (let i = 0; i < data.length; i++) {
      let diff = null;

      withMissedDays.push(data[i]);

      if (!diff || diff === 1) {
        continue;
      }

      for (let day = 1; day < diff; day++) {
        const newX = moment(data[i].x, 'YYYY-MM-DD').add(day, 'days').format('YYYY-MM-DD');

        withMissedDays.push({
          x: newX,
          y: name === 'common.balance' ? data[i].y : 0,
          count: 0,
          payout: name === 'common.balance' ? data[i].payout : undefined,
        });
      }
    }

    const lastDay = withMissedDays[withMissedDays.length - 1];
    const lastDayX = moment(lastDay.x, 'YYYY-MM-DD');

    const diff = lastDayX.diff(new Date(), 'day');
    // differenceInCalendarDays(parseISO(lastDay.x), new Date());

    if (diff > 0) {
      for (let day = 1; day <= diff; day++) {
        const newX = lastDayX.clone().add(day, 'days').format('YYYY-MM-DD');

        withMissedDays.push({
          x: newX, //format(addDays(parseISO(lastDay.x), day), 'YYYY-MM-DD'),
          y: name === 'common.balance' ? lastDay.y : 0,
          count: 0,
          payout: name === 'common.balance' ? 0 : undefined,
        });
      }
    }

    return withMissedDays;
  },

  // сортируем и добавляем пропущенные дни
  toGraphFormat(graph) {
    if (graph[0] && graph[0].data.length < 2) {
      return [];
    }

    const options = {
      'common.balance': {
        colorArc: '#9b51e0',
        gradientLine: ['#9b51e0', '#e71943'],
        gradientFill: ['rgba(60, 36, 55, 0.4)', 'rgba(160, 79, 220, 0)'],
      },
      'common.turnover': {
        colorArc: '#6ad4c0',
        gradientLine: ['#6ad4c0', '#6ad4c0'],
        gradientFill: ['rgba(106, 212, 192, 0.4)', 'rgba(106, 212, 192, 0)'],
      },
    };

    for (let item of graph) {
      item.colorArc = options[item.name].colorArc;
      item.gradientLine = options[item.name].gradientLine;
      item.gradientFill = options[item.name].gradientFill;
      item.show = true;
      item.data = this.addMissedDays(item.data, item.name);
    }

    return graph;
  },
};
